import React from 'react';







function Loading() {
  return (
    <div className='loader-main'>
        <div className="lds-roller">
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
        </div>
    </div>
  );
}

export default Loading;
